import { ApplicationConfig, provideZonelessChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { AuthInterceptor } from './services/auth.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { EntitlementLockoutInterceptor } from './shared/interceptors/entitlement-lockout.interceptor';
import { ErrorHandlerService } from './shared/services/error-handler.service';
import { RateLimitInterceptor } from './shared/interceptors/rate-limit.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Org platform-subscription entitlement lockout (KAN-356 Phase 8 task 8.4c):
    // routes a 402 ORG_SUBSCRIPTION_REQUIRED / ORG_BILLING_PAST_DUE to the
    // chrome-less /billing/locked page. Dark-launch no-op today (every org is
    // billing_required=false), so it never fires until an org opts in.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EntitlementLockoutInterceptor,
      multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorInterceptor,
    //   multi: true
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RateLimitInterceptor,
    //   multi: true
    // },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    provideAnimationsAsync()
  ]
};
